/**
 * 物料借用状态枚举
 */
export enum MaterialBorrowStatus {
  /** 待确认出库 */
  PENDING_BORROW = 0,
  /** 借用中 */
  BORROWING = 1,
  /** 部分归还 */
  PARTIAL_RETURNED = 2,
  /** 已归还 */
  RETURNED = 3,
  /** 待确认归还 */
  PENDING_RETURN = 4,
  /** 已拒绝 */
  REJECTED = 5,
}

/**
 * 物料借用状态标签映射
 */
export const MATERIAL_BORROW_STATUS_LABELS: Record<MaterialBorrowStatus, string> = {
  [MaterialBorrowStatus.PENDING_BORROW]: '待确认出库',
  [MaterialBorrowStatus.BORROWING]: '借用中',
  [MaterialBorrowStatus.PARTIAL_RETURNED]: '部分归还',
  [MaterialBorrowStatus.RETURNED]: '已归还',
  [MaterialBorrowStatus.PENDING_RETURN]: '待确认归还',
  [MaterialBorrowStatus.REJECTED]: '已拒绝',
}

/** 物料借用状态标签（别名，兼容旧代码） */
export const MaterialBorrowStatusLabels = MATERIAL_BORROW_STATUS_LABELS

/**
 * 借用业务类型枚举
 */
export enum BorrowBusinessType {
  /** 借用出库 */
  BORROW_OUT = 'BORROW_OUT',
  /** 借用归还 */
  BORROW_RETURN = 'BORROW_RETURN',
}

/**
 * 借用业务类型标签映射
 */
export const BORROW_BUSINESS_TYPE_LABELS: Record<BorrowBusinessType, string> = {
  [BorrowBusinessType.BORROW_OUT]: '借用出库',
  [BorrowBusinessType.BORROW_RETURN]: '借用归还',
}
